import { render, staticRenderFns } from "./aRefPricesTable.vue?vue&type=template&id=14f075f8&scoped=true"
import script from "./aRefPricesTable.vue?vue&type=script&lang=js"
export * from "./aRefPricesTable.vue?vue&type=script&lang=js"
import style0 from "./aRefPricesTable.vue?vue&type=style&index=0&id=14f075f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f075f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VTooltip})
